import {
  CREATE_AI_AUTOMATION_WORKFLOW,
  CREATE_AI_AUTOMATION_WORKFLOW_SUCCESS,
  CREATE_AI_AUTOMATION_WORKFLOW_FAILURE,
  UPDATE_AI_AUTOMATION_WORKFLOW,
  UPDATE_AI_AUTOMATION_WORKFLOW_SUCCESS,
  UPDATE_AI_AUTOMATION_WORKFLOW_FAILURE,
  DELETE_AI_AUTOMATION_WORKFLOW,
  DELETE_AI_AUTOMATION_WORKFLOW_SUCCESS,
  DELETE_AI_AUTOMATION_WORKFLOW_FAILURE,
  GET_AI_AUTOMATION_WORKFLOW,
  GET_AI_AUTOMATION_WORKFLOW_SUCCESS,
  GET_AI_AUTOMATION_WORKFLOW_FAILURE,
  LIST_AI_AUTOMATION_WORKFLOWS,
  LIST_AI_AUTOMATION_WORKFLOWS_SUCCESS,
  LIST_AI_AUTOMATION_WORKFLOWS_FAILURE,
  EXECUTE_AI_AUTOMATION_WORKFLOW,
  EXECUTE_AI_AUTOMATION_WORKFLOW_SUCCESS,
  EXECUTE_AI_AUTOMATION_WORKFLOW_FAILURE,
} from "../actions/aiAutomationActions";

const initialState = {
  // AI automation workflows
  aiAutomationWorkflows: [],
  aiAutomationWorkflowsConnection: null,
  currentAiAutomationWorkflow: null,
  executionResult: null,

  // Loading states
  aiAutomationLoading: false,
  createAiAutomationLoading: false,
  updateAiAutomationLoading: false,
  deleteAiAutomationLoading: false,
  getAiAutomationLoading: false,
  listAiAutomationLoading: false,
  executeAiAutomationLoading: false,

  // Error states
  aiAutomationError: null,
  createAiAutomationError: null,
  updateAiAutomationError: null,
  deleteAiAutomationError: null,
  getAiAutomationError: null,
  listAiAutomationError: null,
  executeAiAutomationError: null,

  // Success states
  createAiAutomationSuccess: false,
  updateAiAutomationSuccess: false,
  deleteAiAutomationSuccess: false,
  getAiAutomationSuccess: false,
  listAiAutomationSuccess: false,
  executeAiAutomationSuccess: false,
};

const aiAutomationReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create AI automation workflow
    case CREATE_AI_AUTOMATION_WORKFLOW:
      return {
        ...state,
        createAiAutomationLoading: true,
        createAiAutomationError: null,
        createAiAutomationSuccess: false,
      };
    case CREATE_AI_AUTOMATION_WORKFLOW_SUCCESS:
      return {
        ...state,
        createAiAutomationLoading: false,
        createAiAutomationSuccess: true,
        aiAutomationWorkflows: [...state.aiAutomationWorkflows, action.payload],
      };
    case CREATE_AI_AUTOMATION_WORKFLOW_FAILURE:
      return {
        ...state,
        createAiAutomationLoading: false,
        createAiAutomationError: action.payload,
        createAiAutomationSuccess: false,
      };

    // Update AI automation workflow
    case UPDATE_AI_AUTOMATION_WORKFLOW:
      return {
        ...state,
        updateAiAutomationLoading: true,
        updateAiAutomationError: null,
        updateAiAutomationSuccess: false,
      };
    case UPDATE_AI_AUTOMATION_WORKFLOW_SUCCESS:
      return {
        ...state,
        updateAiAutomationLoading: false,
        updateAiAutomationSuccess: true,
        aiAutomationWorkflows: state.aiAutomationWorkflows.map((workflow) =>
          workflow.id === action.payload.id ? action.payload : workflow
        ),
        currentAiAutomationWorkflow: action.payload,
      };
    case UPDATE_AI_AUTOMATION_WORKFLOW_FAILURE:
      return {
        ...state,
        updateAiAutomationLoading: false,
        updateAiAutomationError: action.payload,
        updateAiAutomationSuccess: false,
      };

    // Delete AI automation workflow
    case DELETE_AI_AUTOMATION_WORKFLOW:
      return {
        ...state,
        deleteAiAutomationLoading: true,
        deleteAiAutomationError: null,
        deleteAiAutomationSuccess: false,
      };
    case DELETE_AI_AUTOMATION_WORKFLOW_SUCCESS:
      return {
        ...state,
        deleteAiAutomationLoading: false,
        deleteAiAutomationSuccess: true,
        aiAutomationWorkflows: state.aiAutomationWorkflows.filter(
          (workflow) => workflow.id !== action.payload.id
        ),
        currentAiAutomationWorkflow: null,
      };
    case DELETE_AI_AUTOMATION_WORKFLOW_FAILURE:
      return {
        ...state,
        deleteAiAutomationLoading: false,
        deleteAiAutomationError: action.payload,
        deleteAiAutomationSuccess: false,
      };

    // Get AI automation workflow
    case GET_AI_AUTOMATION_WORKFLOW:
      return {
        ...state,
        getAiAutomationLoading: true,
        getAiAutomationError: null,
        getAiAutomationSuccess: false,
      };
    case GET_AI_AUTOMATION_WORKFLOW_SUCCESS:
      return {
        ...state,
        getAiAutomationLoading: false,
        getAiAutomationSuccess: true,
        currentAiAutomationWorkflow: action.payload,
      };
    case GET_AI_AUTOMATION_WORKFLOW_FAILURE:
      return {
        ...state,
        getAiAutomationLoading: false,
        getAiAutomationError: action.payload,
        getAiAutomationSuccess: false,
      };

    // List AI automation workflows
    case LIST_AI_AUTOMATION_WORKFLOWS:
      return {
        ...state,
        listAiAutomationLoading: true,
        listAiAutomationError: null,
        listAiAutomationSuccess: false,
      };
    case LIST_AI_AUTOMATION_WORKFLOWS_SUCCESS:
      return {
        ...state,
        listAiAutomationLoading: false,
        listAiAutomationSuccess: true,
        aiAutomationWorkflows: action.payload,
      };
    case LIST_AI_AUTOMATION_WORKFLOWS_FAILURE:
      return {
        ...state,
        listAiAutomationLoading: false,
        listAiAutomationError: action.payload,
        listAiAutomationSuccess: false,
      };

    // Execute AI automation workflow
    case EXECUTE_AI_AUTOMATION_WORKFLOW:
      return {
        ...state,
        executeAiAutomationLoading: true,
        executeAiAutomationError: null,
        executeAiAutomationSuccess: false,
      };
    case EXECUTE_AI_AUTOMATION_WORKFLOW_SUCCESS:
      return {
        ...state,
        executeAiAutomationLoading: false,
        executeAiAutomationSuccess: true,
        executionResult: action.payload,
      };
    case EXECUTE_AI_AUTOMATION_WORKFLOW_FAILURE:
      return {
        ...state,
        executeAiAutomationLoading: false,
        executeAiAutomationError: action.payload,
        executeAiAutomationSuccess: false,
      };

    default:
      return state;
  }
};

export default aiAutomationReducer;



